import React from 'react'
import DynamicTextscroll from '../data/DynamicTextscroll'
import ThreeSection from '../components/ThreeSection'
import TestimonialSlider from '../components/TestimonialSlider'
import DynamicClient from '../data/DynamicClient'
import GlobalHiring from '../components/GlobalHiring'
import HireSection from '../components/HireSection'
import BlogSection from '../components/BlogSection'
import { hireDataUSA } from '../data/HiresectionData'
import { hometestimonials, homesliderContent } from '../data/Testimonialdata'
import Hero from '../components/Hero'
import { front_sections } from '../data/ThreesectionData'
import { useNavigate } from 'react-router-dom';
import { headings, homeservices } from '../data/GlobalHiringData'

const Homepage = () => {

  const buttons = [
    { text: "Build Your Workforce" , buttonClass: "homebutton" }
  ];
  const navigate = useNavigate();
  return (
    <>
    <Hero
      title="Empower Your Workforce with the Right Tools!."
      description="Seamless Recruitment, Smooth Onboarding, and Reliable Payments – All in One Place."
      buttonText="Explore More"
      customClass = "front-banner"
      buttonBgColor="hero-button-bg-color"
      imageSrc="images/aihero1.webp"
      squareColor="square-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
    <DynamicTextscroll/>
    <ThreeSection sections={front_sections}/>
    <TestimonialSlider testimonials={hometestimonials} sliderContent={homesliderContent} customClass="homepagetestimonial"/>
    <DynamicClient customClass="homepageclient"/>
    <GlobalHiring services={homeservices} heading={headings.page1}/>
    <HireSection
        imageSrc={hireDataUSA.imageSrc}
        title={hireDataUSA.title}
        description={hireDataUSA.description}
        className={hireDataUSA.className}
        buttonText={buttons}
       
      />
   <Hero
      title="Ready to Transform Your Business for Greater Success?"
      description="Looking to take your business beyond borders? Expand your operations globally with expert advice and tailored strategies. Schedule a consultation with our expansion professionals to discover the benefits of global growth and how we can support your journey."
      buttonText="Book Global Session"
      customClass="secondBanner"
      imageSrc="images/aihero3.webp"
      squareColor="bannersquare-bg-color"
        onButtonClick={() => navigate('meet-the-experts')}
    />
    <BlogSection/>
    <Hero
      title="Need a Fresh Approach to Accelerate Your Business Growth?"
      description="Leverage our proven strategies and technology solutions to transform your business. We provide scalable solutions that drive faster growth and maximize efficiency.."
      buttonText="Expand Your Team"
      customClass="thirdBanner"
      imageSrc="images/aihero2.webp"
      squareColor="thirdsquare-bg-color"
      onButtonClick={() => navigate('/countries')}
    />
    
    </>
  )
}

export default Homepage